import styles from "./Grid.module.css";

// Silly workaround because typescript is not finding css modules
export default styles;